(function($){
  // --- tiny helpers ---
  const i = v => parseInt((v||'').toString().replace(/[^\d\-]/g,''),10)||0;
  const off = (p,c) => (c>0 && p>0 && p<c) ? Math.round((1 - p/c)*100) : 0;
  const norm = s => (s||'').toString().toLowerCase().replace(/\s+/g,'');

  // find frame variant by size text + color (falls back to color-only)
  function findFrameVariant(sizeText, color){
    const sizeN = norm(sizeText), colorN = norm(color);
    const list = Array.isArray(window.mrkFrameData) ? window.mrkFrameData : [];
    for (const v of list){
      const opts = Array.isArray(v.options) && v.options.length ? v.options
                 : [v.option1, v.option2, v.option3].filter(Boolean);
      const hasColor = opts.some(o => norm(o) === colorN);
      const hasSize  = sizeN ? opts.some(o => norm(o).includes(sizeN) || sizeN.includes(norm(o))) : false;
      if ((hasColor && hasSize) || (hasColor && !sizeN)) return {
        id: v.id, price: i(v.price || v.price_cents), compare: i(v.compare_at_price || v.compare_at_price_cents)
      };
    }
    return null;
  }

  function updateItem($it){
    const $sels = $it.find('.mrk-bundle-item-variants .mrk-variant-option');
    const child = $('[name="framing-service-bundle"]').is(':checked');
    const $size = $sels.eq(0), $frame = $sels.eq(1)
    const _size = $it.find('.mrk-bundle-item-variants .mrk-option-option').val();
    let main_variant = null;
    if (child) {
      $size.find('option').each(function () {
        if ($(this).attr('title') == _size) {
          if (child) {
            $(this).prop('selected', true);
          }
          return false;
        }
      })
    }
    $size.find('option').each(function () {
      if ($(this).attr('title') == _size && $(this).attr('frame').toLowerCase().includes($frame.val().toLowerCase())) {
        if (!child)
          $(this).prop('selected', true);
        main_variant = $(this).val();
        return false;
      }
    })
    const $opt = $size.find(':selected');
    const main = {
      id: $size.val(),
      price: i($opt.attr('price')),
      compare: i($opt.attr('compare-price')) || i($opt.attr('price')),
      sizeText: $opt.text()
    };

    let frame = null, frame_system_id = null;
    const frameVal = $frame.length ? $frame.val() : '';
    $($it).find('.mrk-frame-image-item').hide();
    if (frameVal){ 
        frame = findFrameVariant(main.sizeText, frameVal); frame_system_id = $($it).find(`.mrk-frame-image-item[color="${frameVal.toLowerCase()}"]`).attr('data-frame-id');
      $($it).find(`.mrk-frame-image-item[color="${frameVal.toLowerCase()}"]`).show();
    }
    if (!child) {
      frame = null
    }
    const price = main.price + (frame ? frame.price : 0);
    const comp  = main.compare + (frame ? frame.compare : 0);

    // store for totals + inputs
    $it.attr({ 'data-main-id': main.id || '', 'data-frame-id': frame ? frame.id : '', 'data-price': price, 'data-compare': comp, 'data-frame-system-id': frame_system_id ? frame_system_id : '', 'data-main-variant': main_variant ? main_variant : '' });

    // UI
    $it.find('.mrk-bundle-single-price').text(Shopify.formatMoney(price));
    $it.find('.mrk-bundle-single-compare-price').text(comp ? Shopify.formatMoney(comp) : '');
    $it.find('.mrk-bundle-single-discount').text(off(price, comp) ? off(price, comp) + '% OFF' : '');
    if (off(price, comp) > 0) {
      $it.find('.mrk-bundle-item-discount').show();
      $it.find('.mrk-bundle-single-compare-price').show();
    } else {
      $it.find('.mrk-bundle-item-discount').hide();
      $it.find('.mrk-bundle-single-compare-price').hide()
    }
  }

  function rebuild(){
    const $inputsBox = $('.mrk-bundle-form-inputs'); // target container
    let html = '', idx = 0, total = 0, tComp = 0;

    $('.mrk-bundle-item').each(function(){
      const $it = $(this);
      if (!$it.find('.checkbox-upsell_bundles').is(':checked')) return;
      var show = false;
      if ($it.find('.checkbox-upsell_bundles').is(':checked') && $it.find('select:eq(2)').val() != '') {
        show = true;
      }
      // make sure item is current
      if (!$it.attr('data-main-id')) updateItem($it);

      const mainId  = $it.attr('data-main-id');
      const frameId = $it.attr('data-frame-id') || '';
      const frameSystemId = $it.attr('data-frame-system-id') || '';
      const mainVariant = $it.attr('data-main-variant') || '';
      const price   = i($it.attr('data-price'));
      const comp    = i($it.attr('data-compare'));
      const framing_service = !$('[name="framing-service-bundle"]').is(':checked'),
        framing_service_variant = $('[name="framing-service-bundle"]').val(),
        framing_service_compare_price = $('[name="framing-service-bundle"]').data('comparePrice'),
        framing_service_price = $('[name="framing-service-bundle"]').data('price');
      if (mainId && idx == -1) { 
        html += `<input name="id" type="hidden" value="${mainId}">`; 
        if(frameSystemId){ html += `<input name="properties[_frame_id]" type="hidden" value="${frameSystemId}">`;}
        idx++; 
        }
      else if (mainId){
        html += `<input name="items[${idx}][id]" type="hidden" value="${mainId}">`;
        if(frameSystemId){ html += `<input name="items[${idx}][properties[_frame_id]]" type="hidden" value="${frameSystemId}">`;}
        if (mainVariant) { html += `<input name="items[${idx}][properties[_main_variant]]" type="hidden" value="${mainVariant}">`; }
        idx++; 
        }
      if (frameId){
        html += `<input name="items[${idx}][id]" type="hidden" value="${frameId}">`;
        html += `<input name="items[${idx}][parent_id]" type="hidden" value="${mainId}">`;
        idx++;
      }
      if (framing_service && mainVariant && show) {
        html += `<input name="items[${idx}][id]" type="hidden" value="${framing_service_variant}">`;
        html += `<input name="items[${idx}][parent_id]" type="hidden" value="${mainId}">`;
        idx++;
        total += framing_service_price;
        tComp += framing_service_compare_price;
      }

      total  += price;
      tComp  += comp;
    });

    $inputsBox.html(html);
    $('.main-bundle-full-price').text(Shopify.formatMoney(total));
    $('.main-bundle-full-compare-price').text(tComp ? Shopify.formatMoney(tComp) : '');
    $('.mrk-final-bundle-discount').text(off(total, tComp) ? off(total, tComp) + '% OFF' : '0% OFF');
    if (off(total, tComp) > 0) {
      $('.mrk-bundle-footer .mrk-bundle-item-discount').show();
      $('.mrk-bundle-footer .main-bundle-full-compare-price').show();
    } else {
      $('.mrk-bundle-footer .mrk-bundle-item-discount').hide();
      $('.mrk-bundle-footer .main-bundle-full-compare-price').hide();
    }
    $('.mrk-bundle-main-btn').prop('disabled', html === '');
  }
  function updateFramingService() {
    var show = false;
    $('.mrk-bundle-item').each(function () {
      const $it = $(this);
      if (!$it.find('.checkbox-upsell_bundles').is(':checked')) return;

      const frame = $it.find('select:eq(2)').val();
      if (frame != '') {
        show = true;
      }
    });
    if (show) {
      $('.mrk-framing-service-wrapper.bundle').show();
    } else {
      $('.mrk-framing-service-wrapper.bundle').hide();
    }
  }
  $(document).on('change', '.mrk-bundle-item .mrk-variant-option,.mrk-bundle-item .mrk-option-option', function () {
    const $item = $(this).closest('.mrk-bundle-item');
    updateItem($item);
    updateFramingService();
    rebuild();
  });

  $(document).on('change', '.mrk-bundle-item .checkbox-upsell_bundles', function(){
    // ensure prices are set when toggling
    updateItem($(this).closest('.mrk-bundle-item'));
    updateFramingService();
    rebuild();
  });
  $(document).on('change', '[name="framing-service-bundle"]', function () {
    updateFramingService();
    rebuild();
  });
  // initial pass
  $(function(){
    window.mrkFrameData = window.mrkFrameData || [];
    $('.mrk-bundle-item').each(function(){ updateItem($(this)); });
    updateFramingService();
    setTimeout(rebuild, 100);
  });
})(jQuery);